export default function IndustriesHero() {
  return (
    <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-[#09090B]">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c3242c47b976025391e30b060929cf96.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#09090B]/60 via-[#09090B]/40 to-[#09090B]" />
      </div>

      {/* Grid overlay */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.07) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 pt-36 pb-24 text-center">
        <div className="inline-flex items-center gap-2 border border-[#4ADE80]/30 rounded-full px-4 py-1.5 mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-[#4ADE80] animate-pulse inline-block" />
          <span className="text-xs font-semibold uppercase tracking-widest text-[#4ADE80]">
            Industries
          </span>
        </div>

        <h1
          className="text-5xl md:text-7xl font-extrabold text-white leading-tight tracking-tight mb-6"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          Purpose-Built for{" "}
          <span className="text-[#4ADE80]">High-Demand</span> Industries
        </h1>

        <p
          className="text-lg md:text-xl text-white/50 max-w-2xl mx-auto leading-relaxed"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          GroundsWell AI adapts its systems to the unique operational challenges
          of your industry—so nothing falls through the cracks.
        </p>

        <div className="mt-10 flex items-center justify-center gap-8 flex-wrap">
          {["Professional Services", "Contractor & Home Services", "Real Estate & Brokerage"].map((ind) => (
            <span
              key={ind}
              className="text-sm font-medium text-white/40 border border-white/10 rounded-full px-4 py-1.5"
            >
              {ind}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
